import React, { FunctionComponent, SVGAttributes } from 'react';

export const SortArrow: FunctionComponent<SVGAttributes<SVGElement> & { className: string }> = (
  props,
) => (
  <svg width='24' height='25' viewBox='0 0 24 25' fill='none' stroke='none' {...props}>
    <path d='M11.7983 17.5L20.5966 8.7017L3 8.7017L11.7983 17.5Z' fill='#FF7800' />
  </svg>
);
